import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './img/guide_anzhuo.svg'
import _imports_1 from './img/guide_download.svg'
import _imports_2 from './img/guide_finish.svg'
import _imports_3 from './img/load.png'


const _withScopeId = n => (_pushScopeId("data-v-617165b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "guide" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "first" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "img-style"
  })
], -1))
const _hoisted_6 = { class: "small-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "small-content" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line3" }, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "line1"
}
const _hoisted_10 = { class: "first" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "img-style"
  })
], -1))
const _hoisted_12 = { class: "small-title" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line4" }, null, -1))
const _hoisted_15 = {
  key: 1,
  class: "line2"
}
const _hoisted_16 = { class: "first" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "img-style"
  })
], -1))
const _hoisted_18 = { class: "small-title" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "bottom" }
const _hoisted_21 = { class: "b-content" }
const _hoisted_22 = { class: "single" }
const _hoisted_23 = { class: "single" }
const _hoisted_24 = { class: "single" }
const _hoisted_25 = { class: "single" }
const _hoisted_26 = { class: "single" }
const _hoisted_27 = { class: "algin" }
const _hoisted_28 = { class: "percent" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "motionImg"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_reBoundList = _resolveComponent("reBoundList")!
  const _component_noticeDialog = _resolveComponent("noticeDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "title",
      innerHTML: _ctx.divisionTitle()
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("famikeep222.Get the Android device")), 1),
        _hoisted_7,
        _hoisted_8
      ]),
      (_ctx.isShowMore750)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("famikeep222.Install Companion App")), 1),
        _createElementVNode("div", {
          class: "small-content",
          innerHTML: _ctx.getTwoContent()
        }, null, 8, _hoisted_13),
        _hoisted_14
      ]),
      (_ctx.isShowMore750)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("famikeep222.Login to set permissions")), 1),
        _createElementVNode("div", {
          class: "small-content",
          innerHTML: _ctx.getThreeContent()
        }, null, 8, _hoisted_19)
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, "1. " + _toDisplayString(_ctx.$t("guide.tips1")), 1),
        _createElementVNode("div", _hoisted_23, "2. " + _toDisplayString(_ctx.$t("guide.tips2")), 1),
        _createElementVNode("div", _hoisted_24, "3. " + _toDisplayString(_ctx.$t("famikeep220.tips3")), 1),
        _createElementVNode("div", _hoisted_25, [
          _createTextVNode(" 4. " + _toDisplayString(_ctx.$t("guide.tips41")) + " ", 1),
          _createElementVNode("span", {
            class: "a-style",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToDetail && _ctx.goToDetail(...args)))
          }, _toDisplayString(_ctx.$t("guide.detail")), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("guide.tips42")), 1)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createTextVNode(_toDisplayString(_ctx.$t("famikeep222.continue collecting data")) + " ", 1),
          _createElementVNode("span", {
            class: "a-style",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToRebind && _ctx.goToRebind(...args)))
          }, _toDisplayString(_ctx.$t("guide.rebound")), 1)
        ])
      ])
    ]),
    (_ctx.showList)
      ? (_openBlock(), _createBlock(_component_reBoundList, {
          key: 0,
          visible: _ctx.showList,
          onCancle: _ctx.closeList,
          onConfirm: _ctx.reBinding
        }, null, 8, ["visible", "onCancle", "onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.showReboundDialog)
      ? (_openBlock(), _createBlock(_component_noticeDialog, {
          key: 1,
          visible: _ctx.showReboundDialog,
          title: _ctx.$t('pop.changeBound'),
          width: 480,
          info: `${_ctx.$t('pop.reboundText1')} ${_ctx.pickName} ${_ctx.$t(
      'pop.reboundText4'
    )}`,
          onConfirm: _ctx.confirmRebind,
          onCancle: _ctx.closeReboundDialog,
          Cancel: _ctx.$t('pop.no'),
          Okay: _ctx.$t('pop.yes')
        }, null, 8, ["visible", "title", "info", "onConfirm", "onCancle", "Cancel", "Okay"]))
      : _createCommentVNode("", true),
    (_ctx.showReboundFailed)
      ? (_openBlock(), _createBlock(_component_noticeDialog, {
          key: 2,
          visible: _ctx.showReboundFailed,
          title: _ctx.$t('pop.changeBound'),
          width: 480,
          info: `${_ctx.$t('pop.reboundFail1')} ${_ctx.pickName} ${_ctx.$t('pop.reboundFail2')}`,
          onConfirm: _ctx.confirmRebind,
          onCancle: _ctx.closeReboundFailed,
          Cancel: _ctx.$t('pop.cancel'),
          Okay: _ctx.$t('pop.tryAgain')
        }, null, 8, ["visible", "title", "info", "onConfirm", "onCancle", "Cancel", "Okay"]))
      : _createCommentVNode("", true),
    (_ctx.showRebounding)
      ? (_openBlock(), _createBlock(_component_noticeDialog, {
          key: 3,
          visible: _ctx.showRebounding,
          title: _ctx.$t('pop.rebounding'),
          width: 480,
          showclose: false,
          showBtn: false
        }, {
          img: _withCtx(() => [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.percent) + "%", 1),
              _hoisted_29
            ])
          ]),
          _: 1
        }, 8, ["visible", "title"]))
      : _createCommentVNode("", true)
  ]))
}